import * as yup from "yup";
import { PopupFormValues } from "../types";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useState } from "react";
const popupSchema = yup.object({
  startDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      // "" 또는 "null" 같은 값 => null 처리
      if (
        originalValue === "" ||
        originalValue === "null" ||
        originalValue === null
      ) {
        return null;
      }
      return value;
    })
    .typeError("시작일을 선택해주세요.")
    .required("시작일을 선택해주세요."),

  endDate: yup
    .date()
    .nullable()
    .transform((value, originalValue) => {
      if (
        originalValue === "" ||
        originalValue === "null" ||
        originalValue === null
      ) {
        return null;
      }
      return value;
    })
    .typeError("종료일을 선택해주세요.")
    .required("종료일을 선택해주세요.")
    .test(
      "is-after-start",
      "종료일은 시작일 이후여야 합니다.",
      function (value) {
        const { startDate } = this.parent as { startDate?: Date | null };

        // 둘 중 하나라도 없으면 이 룰은 패스 (required는 위에서 이미 처리)
        if (!startDate || !value) return true;

        // 실제 날짜 비교
        return value >= startDate;
      }
    ),
  showYn: yup
    .mixed<"Y" | "N">()
    .oneOf(["Y", "N"], "노출 상태를 선택해주세요.")
    .required("노출 상태를 선택해주세요."),
  solutionCd: yup.string().required("서비스 채널을 선택해주세요."),
  noticeCd: yup.string().required("팝업 유형을 선택해주세요."),
  title: yup.string().max(100).required("제목을 입력해주세요."),
  content: yup.string().max(5000).required("내용을 입력해주세요."),
  imgPosition: yup
    .mixed<"top" | "bottom" | "">()
    .nullable()
    .oneOf(["top", "bottom", ""], "위치를 선택해주세요.")
    .when("file", {
      is: (file: File | null) => file !== null,
      then: (schema) => schema.oneOf(["top", "bottom"], "위치를 선택해주세요."),
      otherwise: (schema) => schema.notRequired(),
    }),
  url: yup
    .string()
    .nullable()
    .transform((value) => (value === "" ? null : value))
    .url("올바른 URL 형식이 아닙니다.")
    .nullable()
    .optional(),
  newTab: yup.boolean(),
});

export default function usePopupForm() {
  const [file, setFile] = useState<File | null>(null);

  const form = useForm<PopupFormValues>({
    resolver: yupResolver(popupSchema),
    defaultValues: {
      startDate: null,
      endDate: null,
      showYn: "Y",
      solutionCd: "ST100002",
      noticeCd: "NT100001",
      title: "",
      content: "",
      imgPosition: "",
      url: null,
      newTabYn: false,
    },
    mode: "onSubmit",
  });

  const handleFile = (file: File | null) => {
    setFile(file);
  };

  return { form, handleFile, file };
}
